import family_01 from './JPEG/family_01.jpg';
import family_02 from './JPEG/family_02.jpg';
import family_03 from './JPEG/family_03.jpg';
import family_04 from './JPEG/family_04.jpg';
import family_05 from './JPEG/family_05.jpg';
import family_06 from './JPEG/family_06.jpg';
import family_07 from './JPEG/family_07.jpg';
import family_08 from './JPEG/family_08.jpg';
import family_09 from './JPEG/family_09.jpg';
import family_10 from './JPEG/family_10.jpg';
import family_11 from './JPEG/family_11.jpg';
import family_12 from './JPEG/family_12.jpg';
import family_13 from './JPEG/family_13.jpg';
import family_14 from './JPEG/family_14.jpg';
import family_16 from './JPEG/family_16.jpg';
import family_17 from './JPEG/family_17.jpg';
import family_18 from './JPEG/family_18.jpg';
import family_19 from './JPEG/family_19.jpg';
import family_20 from './JPEG/family_20.jpg';
import family_21 from './JPEG/family_21.jpg';
import family_22 from './JPEG/family_22.jpg';
import family_24 from './JPEG/family_24.jpg';

const family = [
  family_01,
  family_02,
  family_03,
  family_04,
  family_05,
  family_06,
  family_07,
  family_08,
  family_09,
  family_10,
  family_11,
  family_12,
  family_13,
  family_14,
  family_16,
  family_17,
  family_18,
  family_19,
  family_20,
  family_21,
  family_22,
  family_24,
];

export default family;



// WEBPACK FOOTER //
// ./src/images/family/index.js